import { render, staticRenderFns } from "./MindoMain.vue?vue&type=template&id=62297086&"
import script from "./MindoMain.vue?vue&type=script&lang=js&"
export * from "./MindoMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports